import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<button><!></button>`);

function Button($$anchor, $$props) {
	let variant = $.prop($$props, 'variant', 3, 'primary'),
		size = $.prop($$props, 'size', 3, 'md'),
		fullWidth = $.prop($$props, 'fullWidth', 3, false),
		disabled = $.prop($$props, 'disabled', 3, false);

	var button = root();
	let classes;
	var node = $.child(button);

	$.snippet(node, () => $$props.children);
	$.reset(button);

	$.template_effect(() => {
		classes = $.set_class(button, 1, `btn btn-${variant() ?? ''} btn-${size() ?? ''}`, 'svelte-33nqeufwlll27', classes, { 'full-width': fullWidth() });
		button.disabled = disabled();
	});

	$.delegated('click', button, function (...$$args) {
		$$props.onclick?.apply(this, $$args);
	});

	$.append($$anchor, button);
}

if (import.meta.hot) {
	Button = $.hmr(Button);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-33nqeufwlll27');
		Button[$.HMR].update(module.default);
	});
}

export default Button;

$.delegate(['click']);
import "bun-svelte:Button.svelte-bla8wuo1tkto-style.css";